import React, { Component } from "react";
import { observer } from "mobx-react";
import moment from "moment";
import { comma, partnerIcon, typeTxt } from "utils/Utils";
import { fn_scroll_down, fn_scroll_up } from "function/FnScroll";
import { fn_product_etc_pop } from "../../../../function/FnBodySales";
import SalesEtcPagingBottomView from "./SalesEtcPagingBottomView";

@observer
class SalesProductEtc extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { rootStore } = this.props;
    const layerStore = rootStore.layerStore;
    const salesStore = rootStore.salesStore;
    let startVal = salesStore.getSalesDateVal.start_val;
    let endVal = salesStore.getSalesDateVal.end_val;
    let typeArr = [];
    return (
      <>
        <div className={"layer_comm layer_order_detail " + (layerStore.getLayerProductEtcView ? " layer_open" : "")}>
          <div className="bg"></div>
          <div className="layer_content">
            <div className="article_common_type">
              <div className="section_tit_comm">
                <h1>누락상품 매출 내역</h1>
              </div>
              <div className="section_box_comm">
                <div className="txt">
                  상품정보 인식 오류로 매출조회 시 누락된 상품 내역입니다. <br />
                  자세한 내용은 배달매니저 고객센터(1544-3583)로 문의해 주세요.
                </div>
                <div className="option">
                  <span className="date">조회기간</span>
                  <span>
                    {moment(startVal, "YYYYMMDDHHmmss").format("YYYY - MM - DD")} ~{" "}
                    {moment(endVal, "YYYYMMDDHHmmss").format("YYYY - MM - DD")}
                  </span>
                </div>
              </div>
              <div className="wrap_table layer">
                <table
                  className={
                    Array.isArray(salesStore.getSalesProductEtcList) && salesStore.getSalesProductEtcList.length
                      ? ""
                      : "empty"
                  }
                >
                  <thead>
                    <tr>
                      <th>NO</th>
                      <th className="name">상품명</th>
                      <th>상품유형</th>
                      <th>수량</th>
                      <th>금액</th>
                      <th>누락횟수</th>
                      <th>채널</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(salesStore.getSalesProductEtcList) && salesStore.getSalesProductEtcList.length ? (
                      salesStore.getSalesProductEtcList.map((etc, idx) => (
                        <tr key={idx}>
                          <td className="row_no">{etc.rowNo}</td>
                          <td className="name">
                            <div className="txt_overflow etc">{etc.name}</div>
                          </td>
                          <td className="product_type">
                            {etc.typeList.map((type, idx) => {
                              return typeTxt(type, idx);
                            })}
                          </td>
                          <td className="sales_cnt">{etc.saleCount}</td>
                          <td className="sales_cnt_share">{etc.saleAmount}</td>
                          <td className="sales_amount">{etc.accumulatedCount}</td>
                          <td className="cahnnel">
                            {etc.orderChannels.length != 0 && etc.orderChannels.length == 1 ? (
                              <>
                                <div key="0" className="thumb">
                                  <img src={partnerIcon(etc.orderChannels[0])} width="30" height="30" alt={"logo"} />
                                  <span className="frame"></span>
                                </div>
                                <div key="1" className="thumb"></div>
                              </>
                            ) : (
                              etc.orderChannels.map((channel, idx) => (
                                <div key={idx} className="thumb">
                                  <img src={partnerIcon(channel)} width="30" height="30" alt={"logo"} />
                                  <span className="frame"></span>
                                </div>
                              ))
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="empty" colSpan="10">
                          <span></span>
                          <br />
                          <b>조회된 내역이 없습니다.</b>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {Array.isArray(salesStore.getSalesProductEtcList) && salesStore.getSalesProductEtcList.length ? (
                  <SalesEtcPagingBottomView rootStore={rootStore} />
                ) : null}
              </div>
              <div className="btn_close btn_close_comm">
                <button onClick={event => fn_product_etc_pop(rootStore, false)}>
                  <span>닫기</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SalesProductEtc;
